function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "scale(-1 1)",
  x: -54,
  y: 13.684,
  width: 52,
  height: 35.579,
  rx: 3,
  ry: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.526 13.684v-2.737a4.096 4.096 0 00-4.105-4.105h-6.842a4.096 4.096 0 00-4.106 4.105v2.737M41.684 49.263a2.737 2.737 0 105.474 0M8.842 49.263a2.737 2.737 0 105.474 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.421 13.684v35.579M11.579 13.684v35.579"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.2 13.684V11.77c0-1.59-1.28-2.87-2.87-2.87h-4.785c-1.59 0-2.871 1.28-2.871 2.87v1.914",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgSuitcase = function SvgSuitcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuitcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Suitcase.dcefd176.svg";
export { ForwardRef as ReactComponent };